import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { animated } from 'react-spring/web.cjs';
import TruncatedTooltipText from '@elliemae/ds-basic/TruncatedTooltipText';
import { sortableHandle } from 'react-sortable-hoc';
import GripperVertical from '@elliemae/ds-icons/GripperVertical';
import { isMovable } from '../../helper.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';

var blockName = 'shuttle-list-item';
var Wrapper = aggregatedClasses(animated.li)(blockName);
var ActionsGroup = aggregatedClasses('div')(blockName, 'actions');
var IconWrapper = aggregatedClasses('div')(blockName, 'icon-wrapper');
var Content = aggregatedClasses('label')(blockName, 'content', function (_ref) {
  var isChecked = _ref.isChecked,
      canMove = _ref.canMove,
      isReadonly = _ref.isReadonly;
  return {
    checked: isChecked,
    'can-hover': canMove,
    'read-only': isReadonly
  };
});
var SortHandler = sortableHandle(function () {
  return /*#__PURE__*/React.createElement(GripperVertical, {
    className: "gripper"
  });
});

function ShuttleListItem(_ref2) {
  var _ref2$item = _ref2.item,
      item = _ref2$item === void 0 ? {} : _ref2$item,
      _ref2$showIcons = _ref2.showIcons,
      showIcons = _ref2$showIcons === void 0 ? undefined : _ref2$showIcons,
      _ref2$showIcon = _ref2.showIcon,
      showIcon = _ref2$showIcon === void 0 ? true : _ref2$showIcon,
      _ref2$onSelect = _ref2.onSelect,
      onSelect = _ref2$onSelect === void 0 ? function () {
    return null;
  } : _ref2$onSelect,
      _ref2$isChecked = _ref2.isChecked,
      isChecked = _ref2$isChecked === void 0 ? false : _ref2$isChecked,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? undefined : _ref2$style,
      _ref2$showActions = _ref2.showActions,
      showActions = _ref2$showActions === void 0 ? true : _ref2$showActions,
      _ref2$actions = _ref2.actions,
      actions = _ref2$actions === void 0 ? [] : _ref2$actions,
      _ref2$showSortHandler = _ref2.showSortHandler,
      showSortHandler = _ref2$showSortHandler === void 0 ? false : _ref2$showSortHandler,
      rest = _objectWithoutProperties(_ref2, ["item", "showIcons", "showIcon", "onSelect", "isChecked", "style", "showActions", "actions", "showSortHandler"]);

  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, rest, {
    role: "listitem",
    style: style
  }), /*#__PURE__*/React.createElement(Content, {
    classProps: {
      canMove: isMovable(item),
      isChecked: isChecked,
      isReadonly: item.readyOnly
    },
    onClick: onSelect
  }, showSortHandler && /*#__PURE__*/React.createElement(SortHandler, null), (showIcon || showIcons) && /*#__PURE__*/React.createElement(IconWrapper, null, item.icon), /*#__PURE__*/React.createElement(TruncatedTooltipText, {
    className: "shuttle-tooltip-text",
    value: item.name
  })), showActions && /*#__PURE__*/React.createElement(ActionsGroup, null, actions));
}

export default ShuttleListItem;
//# sourceMappingURL=ShuttleListItem.js.map
